import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { bpBetBuilderRouteI18n } from '../i18n/bp-bet-builder-route-i18n';

export function bpBetBuilderRoutePath(): string {
  return `/${langRouteI18n()}/${bpBetBuilderRouteI18n()}`;
}
